module.exports = __webpack_public_path__ + "static/media/NeoLogo1.f65d29b5.svg";